// 外包 IP 工作台详情弹框标题节点（Offer 谈判详情）。
// 展示标题 + 状态 Tag + 轮次 + 子状态（版权方/商务待确认）+ 关闭。

import React from 'react';
import { Button, Tag } from '@bedrock/components';
import { ChevronLeft, Flow } from '@bedrock/icons-react';
import type { IpCooperationCopyrightOwnerDetailVo } from 'services/api';

interface HeaderProps {
  detail?: IpCooperationCopyrightOwnerDetailVo | null;
  /** 是否可编辑（当前轮 + 版权方待确认；来自外层 DetailDrawer editable，用于区分编辑/只读场景的轮次展示） */
  editable?: boolean;
  /** 关闭抽屉（返回） */
  onClose: () => void;
  /** 打开"状态进度"抽屉 */
  onOpenStatusProgress: () => void;
}

const Header: React.FC<HeaderProps> = ({ detail, onClose, onOpenStatusProgress }) => {
  // 主状态 name：外包端状态体系重构后后端已把 state.name 设为外包端中文名（Offer谈判/Offer待确认/Offer已确认）
  const stateName = detail?.state?.name ?? '';

  return (
    // 走查：头部「关闭」改「返回」（checked-neutral icon button + ChevronLeft）置于标题左侧，状态进度按钮右上；
    // 轮次 tag 不在头部展示（移至出价方案「当前轮次」）；
    // 状态 tag 与标题同容器、置于返回按钮后面（review：标题行向上对齐 items-start）
    <div className="flex flex-col gap-1.5 w-full">
      <div className="flex items-start justify-between gap-2 w-full">
        <div className="flex items-start gap-2 min-w-0 flex-1">
          <Button
            size="small"
            type="checked-neutral"
            icon={<ChevronLeft />}
            aria-label="返回"
            onClick={onClose}
          />

          <span
            className="flex-1 min-w-0 text-color-1 text-lg font-semibold leading-[26px] text-ellipsis overflow-hidden whitespace-nowrap"
            title={detail?.title}>
            {detail?.id != null ? `#${detail.id} ` : ''}
            {detail?.title ?? ''}
            <div>
              {/* 状态 tag 与标题同容器，置于返回按钮后面（review：向上对齐） */}
              {stateName && <Tag size="xSmall" text={stateName} color="brand" />} 
            </div>
          </span>
        </div>
        <div className="flex items-start gap-3 h-full flex-none">
          <Button size="small" type="checked-neutral" icon={<Flow />} onClick={onOpenStatusProgress}>
            状态进度
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Header;
